function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1745579,1.63198796 L21.7122396,10.1700145 C22.1853904,10.6613223 22.1706345,11.4434979 21.6834741,11.9129239 L13.1613124,20.4345459 C12.6716585,20.9227816 11.8794175,20.9216853 11.3866725,20.4274099 C10.9157649,19.9342964 10.9157649,19.1581304 11.3916676,18.6599094 L17.7669236,12.2946342 L1.13532219,12.2942338 C0.492132973,12.2602514 -0.0219445463,11.7462805 -0.0559113607,11.1030339 C-0.0927087856,10.4081287 0.440554729,9.81500571 1.15115041,9.777779 L17.7684388,9.777779 L11.4220861,3.42237116 C11.3644014,3.37418332 11.3109779,3.32058258 11.2622289,3.26222608 C10.8173895,2.72919805 10.8890201,1.93633291 11.4222719,1.49160236 L11.5322969,1.40949971 C12.0597215,1.05861473 12.7765825,1.15301719 13.1745579,1.63198796 Z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.9e71c11d.svg";
export { ForwardRef as ReactComponent };